export default __webpack_public_path__ + "static/mockup-features-2d896e16e0527c28c8f194885d6ce127.webp";